import {
  CruiseQueryStringFilterKeys,
  HotelQueryStringFilterKeys,
  FlightQueryStringFilterKeys,
  SearchModes,
  CarQueryStringFilterKeys,
  CustomInventoryQueryStringFilterKeys,
  TourQueryStringFilterKeys,
} from '../constants';

export default function getSearchFilterQueryFromRouterQuery(routerQuery) {
  let filterNames = CruiseQueryStringFilterKeys;
  if (routerQuery) {
    if (routerQuery.searchMode === SearchModes.HOTEL) filterNames = HotelQueryStringFilterKeys;
    if (routerQuery.searchMode === SearchModes.FLIGHT) filterNames = FlightQueryStringFilterKeys;
    if (routerQuery.searchMode === SearchModes.CAR) filterNames = CarQueryStringFilterKeys;
    if (routerQuery.searchMode === SearchModes.TOUR) filterNames = TourQueryStringFilterKeys;
    if (routerQuery.searchMode === SearchModes.CUSTOM) {
      filterNames = CustomInventoryQueryStringFilterKeys;
    }
  }
  const filteredQuery = {};
  // pick only filter properties
  Object.keys(routerQuery).forEach((queryName) => {
    if (filterNames.some((filterName) => queryName.includes(filterName))) {
      // replace underscores because of these were replaced during encoding
      // selectedAddress[value] have underscore which should not replaced
      filteredQuery[queryName] =
        queryName !== 'sa[value]' &&
        queryName !== 'pickupCode[value]' &&
        queryName !== 'dropoffCode[value]' &&
        routerQuery[queryName].replaceAll
          ? routerQuery[queryName].replaceAll('_', ' ')
          : routerQuery[queryName];
    }
  });
  return filteredQuery;
}
